<template>
  <div class="gift-card-check-off">
    <div class="no-permission" v-if="!checkAuth">{{errorMessage}}</div>
    <gift-card :cardData="cardData" class="gift-card" v-if="checkAuth"></gift-card>
    <div class="gift-card-check-off__desc gift-card-check-off__info">
      <div class="gift-card-check-off__info--name">成本部门：</div>
      <div class="gift-card-check-off__info--value">
        <div class="info-value">{{ cardData.cost_department_name }}</div>
      </div>
    </div>
    <div class="gift-card-check-off__desc gift-card-check-off__info" v-if="cardData.description">
      <div class="gift-card-check-off__info--name">使用说明：</div>
      <div class="gift-card-check-off__info--value">
        <div class="info-value">{{ cardData.description }}</div>
      </div>
    </div>
    <div class="gift-card-check-off__desc gift-card-check-off__info">
      <div class="gift-card-check-off__info--name">发放原因：</div>
      <div class="gift-card-check-off__info--value">
        <template v-if="cardData.reason || (cardData.images && cardData.images.length)">
          <div class="info-value">{{ cardData.reason }}</div>
          <div class="info-imgs" v-if="cardData.images && cardData.images.length">
            <img
              v-for="(imgSrc, index) in cardData.images"
              :key="`${imgSrc}-${index}`"
              :src="imgSrc"
              @click="handlePreview(cardData.images, index)"
            />
          </div>
        </template>
        <div class="info-value" v-else>--</div>
      </div>
    </div>
    <div class="checked-off-amount" v-if="!!checkedAmount">已核销：<span>{{checkedAmount}}</span>元</div>

    <div class="check-off-button" @click="onCheckoffBtnClick" :class="{'card-disabled': !checkAuth || cardData['is_canceled'] || cardData['is_expired']}">核销</div>

    <div class="back-drop" v-show="showCheckOffForm" @click="showCheckOffForm = false"></div>

    <div class="check-off-form-wrap" v-show="showCheckOffForm">
      <div class="check-off-form-wrap__head">
        <div class="check-off-form-wrap__head--title">礼品卡核销</div>
        <div class="check-off-form-wrap__head--tips" v-if="cardData.quota > 0">
          单次消费限额{{formatPrice(cardData.quota)}}元
        </div>
      </div>
      <input v-model="check_amount" type="number" class="inputs check-amount" placeholder="请输入核销金额(元)"/>
      <p class="gift-card-check-off__cost-tips">核销成本{{ giftCardCost }}元</p>
      <input v-model="biz_no" type="text" class="inputs buiness-number" placeholder="业务单号，非必填"/>
      <div class="sperate-line"></div>
      <button class="btn-confirm" @click="onCheckoffCard">确认</button>
    </div>
  </div>
</template>

<script>
import GiftCard from './GiftCard'
export default {
  components: {
    GiftCard
  },
  data() {
    return {
      showCheckOffForm: false,
      check_amount: '',
      checkedAmount: '',
      checkAuth: true,
      biz_no: '',
      errorMessage: '',
      cardData: {
        showDesc: false
      }
    }
  },
  created() {
    this.getGiftCard()
    // this.$store.state.promiseAuth.then(auth => {
    //   this.checkAuth = auth.authList.includes('gift_card.write_off')
    // })
  },
  methods: {
    handlePreview(images, index) {
      this.$wechat.wx.previewImage({
        current: images[index],
        urls: images
      })
    },
    getGiftCard() {
      const code = this.$route.params.code
      this.$rest.gift.getGiftCardByCode({ card_no: code }).then((res) => {
        if (res && res.code === 0) {
          this.cardData = { ...this.cardData, ...res.data }
          this.checkAuth = true
        } else {
          this.showToast(res.message)
          this.checkAuth = false
          this.errorMessage = res.message
        }
      })
    },
    onCheckoffCard() {
      const amount = this['check_amount'] * 100
      const bizNo = this['biz_no']
      if (amount > this.cardData.balance || amount <= 0) {
        this.showToast('当前金额不可用！')
        return
      }
      if (bizNo.length > 30) {
        this.showToast('业务单号字符长度不能超过30个！')
        return
      }
      const data = {
        gift_card_id: this.cardData['gift_card_id'],
        write_off_sum: parseInt(amount, 10),
        biz_no: bizNo
      }
      this.$rest.gift.checkoffGiftCard(data).then(res => {
        if (res && res.code === 0) {
          this.getGiftCard()
          this.showToast('核销成功')
          this.showCheckOffForm = false
          this.checkedAmount = (+this['check_amount']).toFixed(2)
        } else {
          this.showToast(res.message)
        }
      })
    },
    onCheckoffBtnClick() {
      if (!this.checkAuth) return
      this['check_amount'] = ''
      this['biz_no'] = ''
      if (!this.cardData['is_canceled'] && !this.cardData['is_expired']) {
        this.showCheckOffForm = true
      }
    },
    formatPrice(price) {
      const val = (price / 100).toFixed(2)
      const arr = (val + '').split('.')
      if (arr[1] === '00') {
        return parseInt(arr[0], 10)
      }
      return val
    }
  },
  computed: {
    // checkedAmount() {
    //   const amount = this.cardData['face_value'] - this.cardData.balance
    //   return this.formatPrice(amount)
    // }
    giftCardCost() {
      const { cost_rate } = this.cardData

      if (!this.check_amount || isNaN(+this.check_amount) || +this.check_amount <= 0 || !cost_rate) {
        return 0
      }

      return (+this.check_amount * cost_rate).toFixed(2)
    }
  }
}
</script>

<style lang="less" scoped>
@w2: 75rem;

.gift-card-check-off {
  margin-top: 40/@w2;

  &__cost-tips {
    color: #999999;
    font-size: 26/@w2;
    line-height: 37/@w2;
    margin-top: 10/@w2;
    margin-bottom: 3/@w2;
  }

  .no-permission {
    width: 100%;
    height: 100%;
    margin-top: 20%;
    font-size: 18px;
    color: #aaa;
    text-align: center;
  }

  .gift-card {
    margin: 0 auto;
  }
  &__desc {
    padding: 40/@w2 40/@w2 0;
    font-size: 26/@w2;
    color: #666;
  }

  .checked-off-amount {
    text-align: center;
    font-size: 15px;
    margin-top: 30/@w2;
    span {
      color: #fb3f3f;
    }
  }

  .check-off-button {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 90/@w2;
    line-height: 90/@w2;
    text-align: center;
    background-color: #3b5999;
    font-size: 15px;
    color: #ffffff;
    &.card-disabled {
      background-color: #888;
    }
  }

  .back-drop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .check-off-form-wrap {
    position: fixed;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;
    padding: 46/@w2 40/@w2 16/@w2 40/@w2;
    background-color: #ffffff;

    .sperate-line {
      margin: 0 -40/@w2;
      border-top: 1px solid rgba(0, 0, 0, 0.2);
      transform: scaleY(0.5);
    }

    &__head {
      display: flex;
      margin-bottom: 30/@w2;
      justify-content: space-between;
      &--title {
        font-size: 15px;
      }
      &--tips {
        font-size: 24/@w2;
        color: #999999;
      }
    }

    .inputs {
      width: 100%;
      height: 80/@w2;
      padding-left: 30/@w2;
      box-sizing: border-box;
      border: none;
      background-color: #e7e7e9;
      &.buiness-number {
        margin-bottom: 60/@w2;
        margin-top: 30/@w2;
      }
    }

    .btn-confirm {
      margin-top: 16/@w2;
      width: 100%;
      height: 96/@w2;
      color: #fff;
      text-align: center;
      background-color: #3b5999;
      border-radius: 16/@w2;
    }
  }
  &__info {
    display: flex;
    &--name {
      width: 140/@w2;
    }
    &--value {
      flex: 1;
    }
    .info-value {
      margin-top: -6/@w2;
      word-break: break-all;
      line-height: 1.5;
    }
    .info-imgs {
      display: flex;
      flex-wrap: wrap;
      margin-top: 14/@w2;
      img {
        width: 144/@w2;
        height: 144/@w2;
        margin: 0 12/@w2 10/@w2 0;
        border-radius: 9/@w2;
      }
    }
  }
}
</style>
